module.exports = __webpack_public_path__ + "img/thando-profile-min.8cc8d1b0.jpg";